import {useState} from 'react'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DateCalendar} from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import {StyledDateDiv, StyledEndDateTextField} from './UserManagementStyle'
import {Popover} from '@mui/material'
import {PickersDay} from '@mui/x-date-pickers/PickersDay'
import PropTypes from 'prop-types'

const EndDatePickerComponent = ({startDate, endDate, setEndDate, checked, loading}) => {
  const [isEndDatePoperOpen, setIsEndDatePoperOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const handleEndDateChange = (date) => {
    if (dayjs(date).isValid()) {
      setEndDate(dayjs(date).format())
    }
    handleClose()
  }

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget)
    setIsEndDatePoperOpen(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setIsEndDatePoperOpen(false)
  }

  const handleEndDateKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleOpen(event)
    }
  }

  const tomorrow = dayjs().add(1, 'day')
  const dayAfterStartDate = startDate ? dayjs(startDate).add(1, 'day') : dayjs().add(1, 'day')
  const minSelectableDate = tomorrow.isAfter(dayAfterStartDate) ? tomorrow : dayAfterStartDate
  const displayEndDate = endDate !== 'Indefinite' && dayjs(endDate).isValid() ? dayjs(endDate).format('MM/DD/YYYY') : ''
  const calendarValue = endDate !== 'Indefinite' && dayjs(endDate).isValid() ? dayjs(endDate) : null

  return (
    <>
      <StyledDateDiv
        type='button'
        onKeyDown={handleEndDateKeyDown}
        onClick={handleOpen}
        id='end-date'
        aria-expanded={isEndDatePoperOpen}
      >
        <StyledEndDateTextField
          label='Access End date'
          variant='outlined'
          fullWidth
          placeholder='Access End Date'
          inputProps={{'aria-labelledby': 'end-date'}}
          value={displayEndDate}
          InputProps={{
            readOnly: true
          }}
          InputLabelProps={{shrink: true}}
          disabled={!checked || loading}
        />
      </StyledDateDiv>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            value={calendarValue}
            onChange={handleEndDateChange}
            minDate={minSelectableDate}
            views={['year', 'day']}
            referenceDate={calendarValue || minSelectableDate}
            renderDay={(day, DayComponentProps) => <PickersDay {...DayComponentProps}>{day.getDate()}</PickersDay>}
          />
        </LocalizationProvider>
      </Popover>
    </>
  )
}

EndDatePickerComponent.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setEndDate: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  loading: PropTypes.bool
}
export default EndDatePickerComponent
